import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './features/auth/authSlice'
import { chargingSteeringReducer } from './features/chargingSteering/chargingSteeringSlice'
import { feature2ChargingSteeringReducer } from './features/feature2ChargingSteering/feature2ChargingSteeringSlice'
import { vehicleReducer } from './features/vehicle/vehicleSlice'
import { consentsReducer } from './features/consents/consentsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chargingSteering: chargingSteeringReducer,
    feature2ChargingSteering: feature2ChargingSteeringReducer,
    vehicle: vehicleReducer,
    consents: consentsReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
